import { DetailAccordionContainer } from '~/components/DetailAccordion';
import {
  MediaItemOriginal,
  MediaItemRenditions,
  type MediaItemOriginalProps__MediaItem,
  type MediaItemRenditionsProps__MediaItem,
} from './components';

export interface MediaItemVersionsProps {
  mediaItem: MediaItemOriginalProps__MediaItem & MediaItemRenditionsProps__MediaItem;
}

export const MediaItemVersions = ({ mediaItem }: MediaItemVersionsProps) => (
  <DetailAccordionContainer>
    <MediaItemOriginal mediaItem={mediaItem} />
    <MediaItemRenditions mediaItem={mediaItem} />
  </DetailAccordionContainer>
);
